import React from 'react';
import "./index.css"
import assets from "../../util/assets";
import PropTypes from "prop-types";

HideShowReply.propTypes = {
    toggle: PropTypes.func.isRequired,
    replyCount: PropTypes.number.isRequired,
    open: PropTypes.bool.isRequired,
};

const getText = (open,count) => {
    if(count === 1){
        return `${open ? 'Hide' : 'View'} reply`
    }else{
        return `${open ? 'Hide' : 'View'}  ${count} replies`
    }
}

function HideShowReply(props) {
    return (
        <div className="display-flex cursor-pointer" onClick={props.toggle}>
            <span className="view-all-replies">{getText(props.open,props.replyCount)}</span>
            <img src={props.open ? assets.comments.up_arrow : assets.comments.down_arrow} alt={"arrow"} style={{marginLeft:5}}/>
        </div>
    );
}

export default HideShowReply;